import React from 'react';
import { motion } from 'framer-motion';
import { Card, Button } from '../components/Shared';
import SafeIcon from '../common/SafeIcon';
import { FiUser, FiBell, FiLock, FiGlobe, FiDatabase, FiHelpCircle } from 'react-icons/fi';

const Settings = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8 max-w-4xl mx-auto space-y-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white">Settings</h1>
        <p className="text-slate-400 mt-1">Manage your platform preferences and account.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="space-y-2">
          {[
            { icon: FiUser, label: 'Profile', active: true },
            { icon: FiBell, label: 'Notifications', active: false },
            { icon: FiLock, label: 'Security', active: false },
            { icon: FiGlobe, label: 'Integrations', active: false },
            { icon: FiDatabase, label: 'Data Export', active: false },
            { icon: FiHelpCircle, label: 'Support', active: false },
          ].map((item, i) => (
            <button key={i} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${item.active ? 'bg-yellow-400/10 text-yellow-400 border border-yellow-400/20' : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'}`}>
              <SafeIcon icon={item.icon} />
              <span className="font-medium">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="md:col-span-2 space-y-6">
          <Card className="p-6">
            <h3 className="text-lg font-bold text-white mb-4 border-b border-slate-800 pb-2">User Account</h3>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs uppercase tracking-widest text-slate-500 mb-1">First Name</label>
                  <input type="text" defaultValue="Alex" className="w-full bg-[#0A0F1C] border border-slate-700 rounded-lg px-4 py-2 text-white focus:border-yellow-400 outline-none transition-colors" />
                </div>
                <div>
                  <label className="block text-xs uppercase tracking-widest text-slate-500 mb-1">Last Name</label>
                  <input type="text" defaultValue="Mercer" className="w-full bg-[#0A0F1C] border border-slate-700 rounded-lg px-4 py-2 text-white focus:border-yellow-400 outline-none transition-colors" />
                </div>
              </div>
              <div className="pt-4 flex justify-end">
                <Button>Update Profile</Button>
              </div>
            </div>
          </Card>

          <Card className="p-6 border-red-500/20">
            <h3 className="text-lg font-bold text-white mb-4 border-b border-slate-800 pb-2">Danger Zone</h3>
            <div className="flex justify-between items-center bg-red-500/5 p-4 rounded-lg border border-red-500/20">
              <div>
                <p className="text-sm font-bold text-red-400">Purge Demo Data</p>
                <p className="text-xs text-slate-500">This will reset all synthetic records to default.</p>
              </div>
              <button className="text-xs font-bold text-red-400 border border-red-400 px-3 py-1.5 rounded hover:bg-red-400 hover:text-white transition-all">Execute</button>
            </div>
          </Card>
          
          <div className="text-center mt-12 py-8 border-t border-slate-800/50">
            <p className="text-slate-500 text-sm">VendorVista SaaS Platform v2.4.0 (Demo Mode)</p>
            <p className="text-slate-400 mt-2 font-medium tracking-wide">Made by LingLink AI and DigLab AI</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Settings;